import { CJAdVideo, CJAdVideoMethods } from "@stayge/react-cj-ad-video";
import "normalize.css";
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    ReactNativeWebView: any;
  }
}

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const countryCode = urlParams.get("countryCode");
  const adCode = urlParams.get("adCode");
  const hideBottomText = urlParams.get("hideBottomText");
  const buyerId = urlParams.get("buyerId");
  const testMode = urlParams.get("testMode");

  if (!countryCode) {
    throw new Error("Must provide countryCode in query param");
  }

  if (!adCode) {
    throw new Error("Must provide adCode in query param");
  }

  const videoRef = useRef<CJAdVideoMethods>(null);

  useEffect(() => {
    window.addEventListener("message", handleMessage);
  }, []);

  const handleMessage = (event: MessageEvent<any>) => {
    const { data } = event;
    if (data === "play") {
      videoRef.current?.play();
    }
    if (data === "autoPlayError") {
      videoRef.current?.pause();
    }
  };

  const handleSDKLoad = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("AD_SDK_LOAD");
    }
  };

  const handleInitialize = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("AD_INITIALIZE");
    }
  };

  const handleAdsManagerLoaded = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("AD_ADS_MANAGER_LOADED");
    }
  };

  const handleComplete = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("AD_COMPLETE");
    }
  };
  const handleError = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("AD_ERROR");
    }
  };
  const handleAutoPlayError = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("AUTO_PLAY_ERROR");
    }
  };

  return (
    <div className="App" style={{ height: "100vh" }}>
      <CJAdVideo
        ref={videoRef}
        adCode={adCode}
        countryCode={countryCode}
        autoPlay
        deviceType="1"
        hideBottomText={hideBottomText === "true"}
        buyerId={buyerId || undefined}
        onComplete={handleComplete}
        onSDKLoad={handleSDKLoad}
        onAdsManagerLoaded={handleAdsManagerLoaded}
        onInitialize={handleInitialize}
        onError={handleError}
        onAutoPlayError={handleAutoPlayError}
        testMode={testMode === "true"}
      >
        <CJAdVideo.MuteButton />
        <CJAdVideo.PlayButton showOnHover={false} />
        <CJAdVideo.RemainTime />
      </CJAdVideo>
    </div>
  );
}

export default App;
